import { render, staticRenderFns } from "./Box.vue?vue&type=template&id=61a18b3b&"
import script from "./Box.vue?vue&type=script&lang=js&"
export * from "./Box.vue?vue&type=script&lang=js&"
import style0 from "./Box.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/share/tine20/Tinebase/js/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61a18b3b')) {
      api.createRecord('61a18b3b', component.options)
    } else {
      api.reload('61a18b3b', component.options)
    }
    module.hot.accept("./Box.vue?vue&type=template&id=61a18b3b&", function () {
      api.rerender('61a18b3b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/@caohenghu/vue-colorpicker/src/color/Box.vue"
export default component.exports